import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useQuery } from 'data-fetching-client';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Link } from 'foundations-components/transitional/components/Link';
import { useState } from 'react';
import { GET_MIGRATION_ERROR_LINK_QUERY, MIGRATION_REPORT_BY_ID_QUERY } from '../../knowledge-base/queries/KnowledgeBasesQuery';
import { selectCurrentKbMigrationReport } from '../../knowledge-base/selectors/knowledgeBaseDetails';
import UsageTracker from '../../utils/UsageTracker';
import { useAppSelector } from '../../utils/hooks';
import MigrationPublishModal from './MigrationPublishModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MigrationAlert = ({
  screen
}) => {
  const kbMigrationReport = useAppSelector(selectCurrentKbMigrationReport);
  const {
    data: {
      migrationReportById: migrationReport
    } = {
      migrationReportById: undefined
    }
  } = useQuery(MIGRATION_REPORT_BY_ID_QUERY, {
    variables: {
      migrationId: kbMigrationReport.migration.id
    }
  });
  const {
    data: errorLinkData
  } = useQuery(GET_MIGRATION_ERROR_LINK_QUERY, {
    variables: {
      migrationId: kbMigrationReport.migration.id
    }
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const onPublishClick = () => {
    setIsModalOpen(true);
    UsageTracker.track('v3Migration', {
      screen,
      action: 'click-publish-cta',
      isLegacyKnowledgeBase: false
    });
  };
  const onCloseModal = () => {
    setIsModalOpen(false);
  };
  if (!migrationReport) {
    return null;
  }
  const migrationPublishModal = isModalOpen && /*#__PURE__*/_jsx(MigrationPublishModal, {
    closeModal: onCloseModal,
    screen: screen
  });
  if (migrationReport.status === 'SCP_PUBLISHING_FAILED') {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Alert, {
        marginBlock: "500",
        type: "danger",
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3MigrationPublish.alert.publishingFailed.title"
        }),
        children: /*#__PURE__*/_jsxs(ButtonWrapper, {
          children: [/*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.v3MigrationPublish.alert.publishingFailed.description"
            })
          }), /*#__PURE__*/_jsx(PublishButton, {
            onPublishClick: onPublishClick
          })]
        })
      }), migrationPublishModal]
    });
  }
  if (migrationReport.status === 'SCP_PUBLISHING_IN_PROGRESS') {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Alert, {
        marginBlock: "500",
        type: "info",
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3MigrationPublish.alert.publishingInProgress.title"
        }),
        "data-test-id": "publishing-in-progress-alert",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3MigrationPublish.alert.publishingInProgress.description"
        })
      })
    });
  }
  if (migrationReport.status === 'COMPLETED_WITH_ERRORS' && errorLinkData) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Alert, {
        marginBlock: "500",
        type: "warning",
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3MigrationPublish.alert.completedWithErrors.title"
        }),
        children: /*#__PURE__*/_jsxs(ButtonWrapper, {
          children: [/*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "knowledgeContentUI.v3MigrationPublish.alert.completedWithErrors.description_jsx",
              elements: {
                Link
              },
              options: {
                href: `${errorLinkData.migrationErrorLink.url}`
              }
            })
          }), /*#__PURE__*/_jsx(PublishButton, {
            onPublishClick: onPublishClick
          })]
        })
      }), migrationPublishModal]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Alert, {
      marginBlock: "500",
      type: "info",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.v3MigrationPublish.alert.success.title"
      }),
      children: migrationReport.status !== 'MIGRATING' ? /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.v3MigrationPublish.alert.success.description"
          })
        }), /*#__PURE__*/_jsx(PublishButton, {
          onPublishClick: onPublishClick
        })]
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.v3MigrationPublish.alert.migrating.description"
      })
    }), migrationPublishModal]
  });
};
export default MigrationAlert;
function PublishButton({
  onPublishClick
}) {
  return /*#__PURE__*/_jsx(Button, {
    size: "extra-small",
    use: "tertiary",
    onClick: onPublishClick,
    "data-test-id": "open-publish-modal-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.v3MigrationPublish.alert.publishButton"
    })
  });
}